export default {"src":"/_next/static/media/sun-fog.555d8802.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};